import { ProgramType } from '@app/shared/enums';
import { ProgramFilter } from 'src/app/shared/enums/program-filter.enum';

export class CurrentProgramAuthDataModel {
  public Type: ProgramType;
  public Active: boolean;
  public FilterTrainersByLocation: ProgramFilter;
  public FilterTrainersByShift: ProgramFilter;
  public FilterSupervisorsByLocation: ProgramFilter;
  public FilterSupervisorsByShift: ProgramFilter;
  public EnableNRT: boolean;
  public DisplayPowerRecallInsights?: boolean;
  public EnableAiWritingAssistant: boolean;
  public AITraineeSummaryEnabled: boolean;
}
